"use client";

import { FaMicrophoneAlt } from "react-icons/fa";

interface PageLoadingSpinnerProps {
  isLoading: boolean;
}

export default function PageLoadingSpinner({ isLoading }: PageLoadingSpinnerProps) {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[100] pointer-events-none">
      <div className="relative">
        {/* Pulsing ring behind the mic */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full border-2 border-white/30 animate-ping" />
        </div>
        {/* Microphone icon with pulse animation */}
        <FaMicrophoneAlt 
          className="w-10 h-10 text-white animate-pulse" 
        />
      </div>
    </div>
  );
}
